module.exports = Waypoint;


//////////////////
// WEBPACK FOOTER
// external "Waypoint"
// module id = 38
// module chunks = 0